
export const ODDS_BOOST_MARKET_COMPONENT_CLASS = 'odds-boost-market';
export const POST_URL = '/sportsbook-req/getOddsBoostEventsAjax';
export const ODDS_BOOST_LOCATIONS = {
    HOMEPAGE_WIDGET: 1,
    ODDS_BOOST_PAGE: 2,
    SPORTS_PAGE: 3,
    RACING_PAGE: 4,
};
